import { Component, Emit, Mixins, Prop } from 'vue-property-decorator';
import { UtilMixin } from '../../UtilMixin';
import IconText from '../shared/iconText.vue';

@Component({ components: { IconText } })
export default class extends Mixins(UtilMixin) {
  @Prop() public suggestionCandidate!: any;
  public addingItem = false;

  @Emit()
  public added(suggestionCandidate: any) {
    this.addingItem = true;
  }

  public addSuggestion() {
    this.added(
      // this.findSelfUrl(this.publication),
      // this.publication.metadata.identifier,
      this.suggestionCandidate
    );
  }
}
